import { SharedDataContext } from "../agreements/AgreementsPage";
import { DealDocuments } from "./DealDocuments";
import { useState } from "react";

interface ChecklistItem {
  id: string;
  text: string;
}

interface Deal {
  id: string;
  deal_title: string;
  seller_name: string;
  seller_email?: string;
  seller_phone?: string;
  seller_address?: string;
  buyer_name: string;
  buyer_address?: string;
  property_address?: string;
  current_balance?: number;
  payment_amount?: number;
  interest_rate?: number;
  first_payment_date?: string;
  date_of_sale?: string;
  sales_price?: number;
  down_payment_amount?: number;
  beginning_balance?: number;
}

interface DealDocumentsWrapperProps {
  deal: Deal;
  onClose: () => void;
}

/**
 * Wrapper component that provides SharedDataContext to DealDocuments
 * This ensures ChecklistLetter can access context when used within deal management
 */
export function DealDocumentsWrapper({ deal, onClose }: DealDocumentsWrapperProps) {
  const [agreementData, setAgreementData] = useState({
    agreementType: "full" as "full" | "partial",
    primarySellerName: deal.seller_name || "",
    secondarySellerName: "",
    brokerCompanyName: "Contract Funding Group, LLC",
    propertyAddress: deal.property_address || "",
    balance: deal.current_balance?.toString() || "",
    brokerOfferToSeller: "",
    firstPaymentDate: deal.first_payment_date || "",
    dateOfBalance: deal.date_of_sale || new Date().toISOString(),
    date: new Date() as Date | undefined,
    paperType: "land contract",
    partialDollarAmount: "",
    partialEndDate: "",
    originalDownPayment: deal.down_payment_amount?.toString() || "",
    recipientEmail: deal.seller_email || "",
  });

  const [checklistData, setChecklistData] = useState({
    recipientName: deal.seller_name || "",
    recipientEmail: deal.seller_email || "",
    recipientAddress: deal.seller_address || "",
    checklistItems: [] as ChecklistItem[],
  });

  return (
    <SharedDataContext.Provider 
      value={{ 
        agreementData, 
        setAgreementData, 
        checklistData, 
        setChecklistData 
      }}
    >
      <DealDocuments deal={deal} onClose={onClose} />
    </SharedDataContext.Provider>
  );
}
